import { models } from "types/api/viewModels.ts";
import { displayDesigner } from "utils/order.ts";
import { DesignerIsNotHereText } from "components/NewOrders/constants.ts";

// Below code allows the DesignerIsNotHereText to ALWAYS appear as an option as the user searches in the AutoComplete component, no matter what they type in
export const designerOptionsWithCustomDesignerText = (
	options: (models["DesignerViewModel"] | string)[],
	{ inputValue }: { inputValue: string }
) => {
	const upperInputValue = inputValue.toUpperCase();

	const filtered = options.filter(
		(option) => typeof option !== "string" && displayDesigner(option)?.toUpperCase().includes(upperInputValue)
	);

	if (options.includes(DesignerIsNotHereText) && !filtered.includes(DesignerIsNotHereText)) {
		filtered.push(DesignerIsNotHereText);
	}
	return filtered;
};
